import classNames from 'classnames';

import usePage from '../../hooks/usePage';

import Blocks from '../blocks/Blocks';
import UrbaniaButton from '../buttons/UrbaniaButton';
import PageHeader from '../headers/PageHeader';
import PageTheme from '../themes/PageTheme';
import Body from '../typography/Body';
import NotFoundPage from './NotFoundPage';

import styles from '../../styles/pages/page.module.css';

type PageProps = {
    slug: string | null;
    disabled?: boolean;
    entered?: boolean;
    entering?: boolean;
    leaving?: boolean;
    current?: boolean;
    className?: string | null;
    contentClassName?: string | null;
};

function Page({
    slug,
    disabled = false,
    entered = false,
    entering = false,
    leaving = false,
    current = false,
    className = null,
    contentClassName = null,
}: PageProps) {
    const { page = null, notFound = false } = usePage(slug, {
        keepPreviousData: false,
        enabled: !disabled,
    });
    const { id, blocks = [], theme } = page || {};

    if (notFound) {
        return <NotFoundPage current={current} />;
    }
    return (
        <PageTheme
            id={`page-${id}`}
            {...theme}
            containerClassName={styles.container}
            className={classNames([
                styles.container,
                {
                    [styles.entered]: entered,
                    [styles.entering]: entering,
                    [styles.leaving]: leaving,
                },
                className,
                contentClassName,
            ])}
        >
            <PageHeader {...page} className={styles.header} />
            <div className={styles.inner}>
                <UrbaniaButton className={styles.urbania} />
                <Body>
                    <Blocks blocks={blocks} />
                </Body>
            </div>
        </PageTheme>
    );
}

export default Page;
